const INFO = {
	main: {
		title: "Elimimian Osemaoje",
		name: "Elimimian Osemaoje",
		email: "eosemaoje@gmail.com",
		phone: "+2348161908359", 
		logo: "../homepage.jpeg",
	},
	

	socials: {
		twitter: "https://twitter.com/",
		github: "https://github.com/osemaoje",
		linkedin: "https://www.linkedin.com/in/elimimian-osemaoje-484038161?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
		instagram: "https://instagram.com/",
		stackoverflow: "https://stackoverflow.com/",
		facebook: "https://facebook.com/",
	},

homepage: {
  title: "Software Developer",
  description: `
I’m a passionate software engineer who builds scalable, reliable, and high-performance applications that solve real-world problems.  

With expertise in React, Flutter, Dart, Laravel, PHP, and SQL, I craft solutions that are not only functional but also elegant, efficient, and future-proof.  

I thrive on tackling complex challenges, whether it’s architecting a web app, designing a mobile experience, or integrating powerful backend systems.  

My code is clean, maintainable, and follows industry best practices, ensuring every project I deliver is built to last.  

From interactive web apps to feature-rich mobile platforms, I transform ideas into fully functional products that delight users and meet business goals.  

I’m driven by curiosity, continuous learning, and the desire to push the boundaries of what technology can achieve.  

If you’re looking for a developer who combines technical excellence, creativity, and a results-driven mindset, I’m ready to bring your vision to life.  

Let’s build something extraordinary together.
  `,
},

about: {
  title: "I am Elimimian Osemaoje (OJE) and I live in Lagos, Nigeria",
  description: (
    <>
      <p>
        I am a versatile Software Developer with over 4 years of experience building web and mobile applications that are scalable, secure, and user-friendly.
      </p>

      <p>
        I specialize in React, Flutter, Dart, Laravel & PHP, and SQL, and I am passionate about writing clean, maintainable code that adheres to industry best practices.
      </p>

      <p>
        Throughout my career, I have successfully delivered high-impact projects across multiple domains:
      </p>

      <ul>
        <li>
          <strong>Marvel Harry Academy (Mobile App)</strong> – An e-learning platform built with Flutter, offering interactive courses and gamified learning experiences for students.
        </li>
        <li>
          <strong>Iyoyo Foods (E-commerce App)</strong> – A full-featured food ordering app, built with Flutter and integrated with backend systems for seamless ordering, payment, and delivery tracking.
        </li>
        <li>
          <strong>Assemblies of God Sunday School Manual App</strong> – A mobile app that provides structured lessons and resources for Sunday school students, ensuring an engaging learning experience.
        </li>
        <li>
          <strong>Pluto AI Wallet & Blockchain Integration</strong> – A Web3 wallet and AI-powered assistant, integrated with Sepolia Ethereum testnet, allowing users to view balances, send tokens, and interact with blockchain data.
        </li>
      </ul>

      <p>
        I thrive on solving complex challenges, optimizing application performance, and creating digital solutions that make an impact.
      </p>

      <p>
        My approach combines technical expertise, innovative thinking, and a results-driven mindset to ensure every project I deliver exceeds expectations.
      </p>
    </>
  ),
},



	articles: {
		title: "I'm passionate about pushing the boundaries of what's possible and inspiring the next generation of innovators.",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
	},

	projects: [
		{
			title: "Marvel Harry Academy",
			description:
				"An e-learning platform designed to deliver structured educational content tailored for adult learners.",
			logo: "../Marvel.jpg",
			linkText: "View Project",
			link: "/mhat",
		},

		{
			title: "Iyoyo Foods",
			description:
				"A mobile application that provides a convenient and efficient platform for ordering meals and food services.",
			logo: "../iyoyo.png",
			linkText: "View Project",
			link: "/iyoyofoods",
		},


				{
			title: "Pluto AI Bot",
			description:
				"A Web3-powered AI assistant offering insights and support on blockchain technology and decentralized ecosystems.",
			logo: "../pluto.png",
			linkText: "View Project",
			link: "/plutoai",
		},

				{
			title: "Assemblies of God Sunday School Manual App",
			description:
				"A digital solution that transforms the Sunday School manual into an accessible and user-friendly mobile application.",
			logo: "../introduction_animation.png",
			linkText: "View Project",
			link: "/agapp",
		},
	],
};

export default INFO;
